/** @jsxImportSource theme-ui */
import React, { useState } from "react";
import { Box, Text } from "theme-ui";
import Icon from "./common/Icon";
import { IconButton } from "theme-ui";

type CustomSelectProps = {
    options: string[];
    onSelect: (selectedItem: string) => void;
};

const CustomSelect: React.FC<CustomSelectProps> = ({ options, onSelect }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleSelect = (option: string) => {
        setIsOpen(false);
        onSelect(option);
    };

    const handleToggle = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box>
                <IconButton onClick={handleToggle} sx={{ cursor: 'pointer', backgroundColor: 'background', "&:hover": { opacity: 0.7 } }}>
                    <Icon name="pencil" size={[12, 16]} />
                </IconButton>
                {isOpen && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: "calc(100% + 10px)",
                            left: "0",
                            width: "100%",
                            backgroundColor: "white",
                            border: "2px solid #F5F9FC",
                            borderRadius: "15px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            zIndex: 10,
                            maxHeight: "200px", // Limit height to show 5 items
                            overflowY: "auto",
                        }}
                    >
                        {options.map((option, index) => (
                            <Box
                                key={index}
                                sx={{
                                    padding: "12px 16px",
                                    cursor: "pointer",
                                    fontSize: ["14px", "16px"],
                                    color: "text",
                                    ":hover": {
                                        backgroundColor: "#f0f0f0",
                                    },
                                }}
                                onClick={() => handleSelect(option)}
                            >
                                <Text
                                    sx={{
                                        color: "primaryText",
                                        fontSize: ["14px", "16px"],
                                    }}
                                >
                                    {option}
                                </Text>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default CustomSelect;